webpackJsonp([1],{

/***/ 114:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var MainView = function (_React$Component) {
  _inherits(MainView, _React$Component);

  function MainView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MainView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MainView.__proto__ || Object.getPrototypeOf(MainView)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        viewType: _this.props.initialViewType,
        viewData: _this.props.initialViewData
      }
    }), Object.defineProperty(_this, 'setView', {
      enumerable: true,
      writable: true,
      value: function value(viewType, viewData) {
        _this.setState({ viewType: viewType, viewData: viewData });
      }
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MainView, [{
    key: 'render',
    value: function render() {
      var viewData = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.extend({}, this.state.viewData, {
        setView: this.setView
      });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.state.viewType, viewData);
    }
  }]);

  return MainView;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

Object.defineProperty(MainView, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    initialViewType: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.func.isRequired,
    initialViewData: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.object
  }
});


/* harmony default export */ __webpack_exports__["a"] = (MainView);

/***/ }),

/***/ 115:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_helpers_I18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_helpers_I18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_helpers_I18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var AudioPlayer = function (_React$Component) {
  _inherits(AudioPlayer, _React$Component);

  function AudioPlayer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AudioPlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AudioPlayer.__proto__ || Object.getPrototypeOf(AudioPlayer)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        halfSpeed: false
      }
    }), Object.defineProperty(_this, 'handleHalfSpeedChanged', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        _this.setState({ halfSpeed: e.target.checked });
      }
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AudioPlayer, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isPlaying) {
        if (!this.isPlaying()) {
          this.refs.audio.play();
        }
      } else {
        if (this.isPlaying()) {
          this.refs.audio.pause();
        }
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.refs.audio.playbackRate = this.refs.audio.defaultPlaybackRate = nextState.halfSpeed ? 0.5 : 1.0;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.isPlaying) {
        this.refs.audio.play();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.isPlaying()) {
        this.refs.audio.pause();
      }
    }
  }, {
    key: 'isPlaying',
    value: function isPlaying() {
      return this.refs.audio.currentTime > 0 && !this.refs.audio.paused && !this.refs.audio.ended && this.refs.audio.readyState > 2;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'm-tb-5' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'audio',
          { controls: true, ref: 'audio',
            preload: this.props.preload ? "auto" : "none",
            onPlay: this.props.onPlay,
            onPause: this.props.onPause },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('source', { src: this.props.audioURL })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'checkbox m-b-0' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'label',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { type: 'checkbox', defaultChecked: this.state.halfSpeed, onChange: this.handleHalfSpeedChanged }),
            __WEBPACK_IMPORTED_MODULE_0_helpers_I18n___default.a.t("audio_player.half_speed")
          )
        )
      );
    }
  }]);

  return AudioPlayer;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

Object.defineProperty(AudioPlayer, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    isPlaying: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.bool,
    audioURL: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.string.isRequired,
    preload: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.bool,
    onPlay: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.func,
    onPause: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.func
  }
});
Object.defineProperty(AudioPlayer, 'defaultProps', {
  enumerable: true,
  writable: true,
  value: {
    preload: true,
    onPlay: function onPlay() {},
    onPause: function onPause() {}
  }
});


/* harmony default export */ __webpack_exports__["a"] = (AudioPlayer);

/***/ }),

/***/ 116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_superagent__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers_FormErrors__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers_FormErrors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_helpers_FormErrors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_I18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_I18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_helpers_I18n__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var SendUserbar = function (_React$Component) {
  _inherits(SendUserbar, _React$Component);

  function SendUserbar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SendUserbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SendUserbar.__proto__ || Object.getPrototypeOf(SendUserbar)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        email: __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get("email"),
        changingEmail: __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get("email") === undefined,
        submitting: false,
        submitted: false,
        errors: new __WEBPACK_IMPORTED_MODULE_4_helpers_FormErrors___default.a()
      }
    }), Object.defineProperty(_this, 'handleEmailChange', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        var newEmail = e.target.value;
        _this.setState({ email: newEmail });
      }
    }), Object.defineProperty(_this, 'handleSendToDifferentEmailClick', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        e.preventDefault();
        _this.setState({ changingEmail: true });
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        e.preventDefault();

        if (_this.state.submitting) {
          return;
        }

        _this.setState({ submitting: true, errors: new __WEBPACK_IMPORTED_MODULE_4_helpers_FormErrors___default.a() });
        var modelForSubmit = _this.getModelForSubmit();
        __WEBPACK_IMPORTED_MODULE_0_superagent___default.a.post(_this.props.submitURL).send(modelForSubmit).set("X-CSRF-Token", window.SessionManager.getCSRFToken()).set("Accept", "application/json").then(function (_res) {
          _this.setState({ submitted: true, submitting: false });
          __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.set("email", _this.state.email);
        }).catch(function (err) {
          var errors = void 0;
          if (err.status === 422) {
            errors = new __WEBPACK_IMPORTED_MODULE_4_helpers_FormErrors___default.a(err.response.body.errors.account, "userbar.errors");
          } else {
            errors = new __WEBPACK_IMPORTED_MODULE_4_helpers_FormErrors___default.a({ errors: ["generic_error"] }, "userbar.errors");
          }
          _this.setState({ errors: errors, submitting: false });
        });
      }
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SendUserbar, [{
    key: 'getModelForSubmit',
    value: function getModelForSubmit() {
      return {
        account: {
          email: this.state.email,
          userbar_token: this.props.userbarToken
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.submitted) {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: 'p-t-20 p-b-20' },
          __WEBPACK_IMPORTED_MODULE_5_helpers_I18n___default.a.t("userbar.sent"),
          ' ',
          this.state.email
        );
      }

      var submitButton = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'button',
        { className: 'btn btn-primary', disabled: this.state.submitting },
        __WEBPACK_IMPORTED_MODULE_5_helpers_I18n___default.a.t("userbar.send")
      );

      var children = void 0;
      if (this.state.changingEmail) {
        children = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()({ "has-error": this.state.errors.get("email").hasAny() }) },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', { type: 'text',
            className: 'form-control',
            placeholder: 'Email',
            defaultValue: this.state.email,
            onChange: this.handleEmailChange }),
          " ",
          submitButton,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'span',
            { className: 'help-block text-danger' },
            this.state.errors.get("email").firstError()
          )
        );
      } else {
        children = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'p',
            null,
            __WEBPACK_IMPORTED_MODULE_5_helpers_I18n___default.a.t("userbar.will_send_to"),
            ' ',
            this.state.email
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'div',
            null,
            submitButton,
            " ",
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'a',
              { href: 'javascript:;', onClick: this.handleSendToDifferentEmailClick },
              __WEBPACK_IMPORTED_MODULE_5_helpers_I18n___default.a.t("userbar.different_email")
            )
          )
        );
      }

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'form',
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("form-inline p-t-20 p-b-20", { "has-error": this.state.errors.hasAny() }), onSubmit: this.handleSubmit },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'h4',
          null,
          __WEBPACK_IMPORTED_MODULE_5_helpers_I18n___default.a.t("userbar.header")
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'p',
          { className: 'p-t-10' },
          __WEBPACK_IMPORTED_MODULE_5_helpers_I18n___default.a.t("userbar.text")
        ),
        children,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'span',
          { className: 'help-block text-danger' },
          this.state.errors.firstError()
        )
      );
    }
  }]);

  return SendUserbar;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Object.defineProperty(SendUserbar, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    submitURL: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
    submitMethod: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.oneOf(["POST"]).isRequired,
    userbarToken: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired
  }
});


/* harmony default export */ __webpack_exports__["a"] = (SendUserbar);

/***/ }),

/***/ 148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_application_AudioPlayer__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_application_SendUserbar__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_I18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_I18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_helpers_I18n__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var TestResults = function (_React$Component) {
  _inherits(TestResults, _React$Component);

  function TestResults() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TestResults);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TestResults.__proto__ || Object.getPrototypeOf(TestResults)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        currentPlayingQuestionId: undefined
      }
    }), Object.defineProperty(_this, 'handlePlay', {
      enumerable: true,
      writable: true,
      value: function value(questionId) {
        _this.setState({ currentPlayingQuestionId: questionId });
      }
    }), Object.defineProperty(_this, 'handlePause', {
      enumerable: true,
      writable: true,
      value: function value(questionId) {
        if (questionId === _this.state.currentPlayingQuestionId) {
          _this.setState({ currentPlayingQuestionId: null });
        }
      }
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TestResults, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var answersByQuestionId = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.reduce(this.props.answers, function (r, a) {
        r[a.question_id] = a;
        return r;
      }, {});

      var questionResults = this.props.questions.map(function (q, i) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'col-md-6', key: q.id },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TestResults.QuestionResult, { number: i + 1,
            question: q,
            selectedAnswerId: answersByQuestionId[q.id].selected_answer_id,
            correctAnswerId: answersByQuestionId[q.id].correct_answer_id,
            isPlaying: q.id === _this2.state.currentPlayingQuestionId,
            onPlay: _this2.handlePlay,
            onPause: _this2.handlePause })
        );
      });

      var questionResultPairs = [];
      questionResults.forEach(function (qr, i) {
        if (i % 2 == 0) {
          var pair = [qr];
          questionResultPairs.push(pair);
        } else {
          questionResultPairs[questionResultPairs.length - 1].push(qr);
        }
      }, this);

      var rows = questionResultPairs.map(function (qrPair, i) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'row', key: i },
          qrPair
        );
      }, this);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'page-header' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h1',
            { className: 'm-b-0' },
            __WEBPACK_IMPORTED_MODULE_5_helpers_I18n___default.a.t("test_results.title")
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h2',
          { className: 'p-t-15' },
          __WEBPACK_IMPORTED_MODULE_5_helpers_I18n___default.a.t("test_results.score") + ': ' + this.props.score + '/' + this.props.totalQuestions
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TestResults.PublicURL, { uuid: this.props.uuid }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_application_SendUserbar__["a" /* default */], { userbarToken: this.props.userbarToken,
          submitURL: this.props.sendUserbarURL,
          submitMethod: this.props.sendUserbarMethod }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'form' },
          rows
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'ul',
          { className: 'list-inline p-t-20 p-b-20' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'li',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { href: '/tests/new?topic_id=' + this.props.topicId },
              __WEBPACK_IMPORTED_MODULE_5_helpers_I18n___default.a.t("test_results.another")
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'li',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { href: this.props.backURL },
              __WEBPACK_IMPORTED_MODULE_5_helpers_I18n___default.a.t("test_results.back")
            )
          )
        )
      );
    }
  }]);

  return TestResults;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

Object.defineProperty(TestResults, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    sendUserbarURL: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.string.isRequired,
    sendUserbarMethod: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.oneOf(["POST"]).isRequired,
    backURL: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.string.isRequired,
    uuid: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.string.isRequired,
    questions: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.arrayOf(__WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.object).isRequired,
    answers: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.arrayOf(__WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.object).isRequired,
    score: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.number.isRequired,
    totalQuestions: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.number.isRequired,
    userbarToken: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.string,
    topicId: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.number.isRequired
  }
});

var TestResultsQuestionResult = function (_React$Component2) {
  _inherits(TestResultsQuestionResult, _React$Component2);

  function TestResultsQuestionResult() {
    var _ref2;

    var _temp2, _this3, _ret2;

    _classCallCheck(this, TestResultsQuestionResult);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref2 = TestResultsQuestionResult.__proto__ || Object.getPrototypeOf(TestResultsQuestionResult)).call.apply(_ref2, [this].concat(args))), _this3), Object.defineProperty(_this3, 'handlePlay', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this3.props.onPlay(_this3.props.question.id);
      }
    }), Object.defineProperty(_this3, 'handlePause', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this3.props.onPause(_this3.props.question.id);
      }
    }), _temp2), _possibleConstructorReturn(_this3, _ret2);
  }

  _createClass(TestResultsQuestionResult, [{
    key: 'answerClassNames',
    value: function answerClassNames(ao) {
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()("answer", {
        "correct": this.isCorrect(ao),
        "incorrect": !this.isCorrect(ao),
        "submitted": this.isChosen(ao)
      });
    }
  }, {
    key: 'isCorrect',
    value: function isCorrect(ao) {
      return ao.id === this.props.correctAnswerId;
    }
  }, {
    key: 'isChosen',
    value: function isChosen(ao) {
      return ao.id === this.props.selectedAnswerId;
    }
  }, {
    key: 'answerNote',
    value: function answerNote(ao) {
      if (this.isCorrect(ao)) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'text-success' },
          ' \u2013 ' + __WEBPACK_IMPORTED_MODULE_5_helpers_I18n___default.a.t("test_results.is_correct_answer")
        );
      } else if (this.isChosen(ao)) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'text-danger' },
          ' \u2013 ' + __WEBPACK_IMPORTED_MODULE_5_helpers_I18n___default.a.t("test_results.is_selected_answer")
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var audio = void 0;
      if (this.props.question.audio_url) {
        audio = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_application_AudioPlayer__["a" /* default */], { preload: false,
          audioURL: this.props.question.audio_url,
          isPlaying: this.props.isPlaying,
          onPlay: this.handlePlay,
          onPause: this.handlePause });
      }
      var radios = this.props.question.answer_options.map(function (ao) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { key: ao.id, className: 'radio' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'label',
            { className: _this4.answerClassNames(ao) },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { name: _this4.props.question.id,
              type: 'radio',
              checked: _this4.isChosen(ao),
              disabled: true,
              onChange: _this4.handleSelectedAnswerChange }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { className: 'radio-label' },
              ao.text,
              _this4.answerNote(ao)
            )
          )
        );
      });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'question' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h3',
          { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({ "incorrect": this.props.correctAnswerId != this.props.selectedAnswerId }) },
          __WEBPACK_IMPORTED_MODULE_5_helpers_I18n___default.a.t("test_results.question") + ' ' + this.props.number
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { className: 'p-t-5' },
          this.props.question.text
        ),
        audio,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          radios
        )
      );
    }
  }]);

  return TestResultsQuestionResult;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

Object.defineProperty(TestResultsQuestionResult, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    number: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.number.isRequired,
    question: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.object.isRequired,
    selectedAnswerId: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.number,
    correctAnswerId: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.number,
    isPlaying: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.bool.isRequired,
    onPlay: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.func.isRequired,
    onPause: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.func.isRequired
  }
});

var TestResultsPublicURL = function (_React$Component3) {
  _inherits(TestResultsPublicURL, _React$Component3);

  function TestResultsPublicURL() {
    var _ref3;

    var _temp3, _this5, _ret3;

    _classCallCheck(this, TestResultsPublicURL);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret3 = (_temp3 = (_this5 = _possibleConstructorReturn(this, (_ref3 = TestResultsPublicURL.__proto__ || Object.getPrototypeOf(TestResultsPublicURL)).call.apply(_ref3, [this].concat(args))), _this5), Object.defineProperty(_this5, 'handleClicked', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        e.target.select();
      }
    }), _temp3), _possibleConstructorReturn(_this5, _ret3);
  }

  _createClass(TestResultsPublicURL, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'form',
        { className: 'test-public-result form-inline p-t-15 p-b-20' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h4',
          null,
          __WEBPACK_IMPORTED_MODULE_5_helpers_I18n___default.a.t("test_results.public_url")
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { type: 'text',
          className: 'form-control',
          readOnly: true,
          size: '80',
          onClick: this.handleClicked,
          value: Routes.testResultPreviewURL(this.props.uuid) })
      );
    }
  }]);

  return TestResultsPublicURL;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

Object.defineProperty(TestResultsPublicURL, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    uuid: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.string.isRequired
  }
});


TestResults.QuestionResult = TestResultsQuestionResult;
TestResults.PublicURL = TestResultsPublicURL;
/* harmony default export */ __webpack_exports__["a"] = (TestResults);

/***/ }),

/***/ 149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Youtube = function (_React$Component) {
  _inherits(Youtube, _React$Component);

  function Youtube() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Youtube);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Youtube.__proto__ || Object.getPrototypeOf(Youtube)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, "state", {
      enumerable: true,
      writable: true,
      value: {
        loaded: false
      }
    }), Object.defineProperty(_this, "handleClick", {
      enumerable: true,
      writable: true,
      value: function value(e) {
        e.preventDefault();

        _this.setState({ loaded: true });
      }
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Youtube, [{
    key: "thumbnailURL",
    value: function thumbnailURL() {
      var urlParser = document.createElement("a");
      urlParser.href = this.props.videoEmbedURL;
      var videoID = urlParser.pathname.replace("/embed/", "");

      return "https://i.ytimg.com/vi/" + videoID + "/hqdefault.jpg";
    }
  }, {
    key: "embedURL",
    value: function embedURL() {
      var urlParser = document.createElement("a");
      urlParser.href = this.props.videoEmbedURL;
      urlParser.search = "?autoplay=1&autohide=1&rel=0&showinfo=0"; // for embedding
      urlParser.search += this.props.controls ? "&controls=1" : "&controls=0";
      return urlParser.href;
    }
  }, {
    key: "render",
    value: function render() {
      var notLoaded = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "video-placeholder embed-responsive-item",
          style: { backgroundImage: "url(" + this.thumbnailURL() + ")" },
          title: this.props.alt,
          onClick: this.handleClick },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "play" })
      );
      var loaded = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("iframe", { frameBorder: "0", src: this.embedURL(), allowFullScreen: this.props.allowFullScreen });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "embed-responsive embed-responsive-16by9" },
        this.state.loaded ? loaded : notLoaded
      );
    }
  }]);

  return Youtube;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Object.defineProperty(Youtube, "propTypes", {
  enumerable: true,
  writable: true,
  value: {
    videoEmbedURL: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.string.isRequired,
    alt: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.string,
    controls: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.bool,
    allowFullScreen: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.bool
  }
});


/* harmony default export */ __webpack_exports__["a"] = (Youtube);

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

var I18n = {
  currentLocale: "ru",
  t: function t(key) {
    var ts = I18n.translations[I18n.currentLocale];
    var missing = false;
    key.split(".").forEach(function (k) {
      if (missing) {
        return;
      }
      if (!ts.hasOwnProperty(k)) {
        missing = true;
        return;
      }
      ts = ts[k];
    });
    if (missing) {
      console.log("missing translation for " + key);
      return key;
    } else if (typeof ts !== "string") {
      console.log("missing translation for " + key + ": not a string", ts);
      return key;
    } else {
      return ts;
    }
  },

  translations: {
    ru: {
      jstest: {
        nested: {
          "foo": "bar"
        }
      },
      audio_player: {
        half_speed: "Замедлить"
      },
      login_page: {
        title: "Вход",
        text: "Войдите с помощью одной из социальных сетей, чтобы сохранить результат.",
        skip: "Не хочется, просто покажите мне результат"
      },
      test_wizard: {
        previous: "Назад",
        next: "Вперед",
        submit: "Готово!",
        question: "Вопрос",
        answer_options: "Варианты ответов",
        back: "Другой тест",
        errors: {
          generic_error: "Произошла ошибка. Пожалуйста, попробуйте чуть позже",
          failed_to_grade: "Ой! Произошла ошибка. Пожалуйста, попробуйте еще раз, чуть позже.",
          failed_to_persist: "Ой! Произошла ошибка. Пожалуйста, попробуйте еще раз, чуть позже."
        }
      },
      test_results: {
        title: "Результаты теста",
        score: "Ваш результат",
        public_url: "Ссылка на результат для ВКонтакте",
        back: "Другой тест",
        another: "Еще раз",
        is_correct_answer: "Правильный ответ",
        is_selected_answer: "Ваш ответ",
        question: "Вопрос"
      },
      userbar: {
        header: "Юзербар для форума",
        text: "Если вы хотите получить результаты в виде юзербара, чтобы показать другим — введите ваш e-mail и мы отправим его вам на указанный адрес",
        sent: "Юзербар отправлен на",
        will_send_to: "Юзербар будет отправлен на",
        different_email: "другой email",
        send: "Получить юзербар!",
        errors: {
          generic_error: "Произошла ошибка. Попробуйте еще раз.",
          save_email_failed: "Произошла ошибка. Попробуйте еще раз.",
          send_userbar_failed: "Произошла ошибка. Попробуйте еще раз.",
          email: {
            must_not_be_empty: "Email не может быть пустым"
          },
          userbar_token: {
            must_not_be_empty: "Не удалось сгенерировать юзербар"
          }
        }
      },
      edit_question_form: {
        text: "Текст вопроса",
        answers: "Варианты ответов",
        answer_placeholder: "Текст ответа",
        remove_answer: "Убрать",
        add_answer: "Добавить ответ",
        save: "Сохранить Вопрос",
        remove: "Удалить Вопрос",
        errors: {
          text: {
            must_not_be_empty: "Не может быть пустым"
          },
          answers: {
            must_have_at_least_one_correct_answer: "Нужно указать правильный ответ",
            must_have_at_least_2: "Нужно хотя бы два ответа",
            text: {
              must_not_be_empty: "Не может быть пустым"
            }
          }
        }
      },
      bulk_question_form: {
        submit: "Добавить вопросы",
        required: "обязательное поле",
        question_template: "Текст вопроса",
        question_template_placeholder: "Вопрос...",
        answer_options: "Варианты ответов",
        answer_option_placeholder: "Ответ...",
        add_answer_option: "Добавить ответ",
        remove_answer_option: "Убрать",
        drop_here: "Перетащите файлы сюда",
        files: "Файлы",
        table: {
          filename: "Имя файла",
          player: "Плеер",
          answer: "Ответ",
          remove_file: "Убрать"
        },
        errors: {
          question_template: {
            must_not_be_empty: "Не может быть пустым"
          },
          answer_options: {
            must_have_at_least_2: "Нужно хотя бы 2",
            text: {
              must_not_be_empty: "Не может быть пустым"
            }
          },
          files: {
            must_have_at_least_1: "Нужен хотя бы один файл",
            must_select_answer_option: "Нужно выбрать ответ"
          }
        }
      },
      topics_list: {
        table: {
          headers: {
            name: "Название",
            level_name: "Уровень",
            questions_count: "Вопросы",
            published: "Опубликован",
            featured: "\"Новый\""
          },
          actions: {
            edit: "Изменить",
            add_questions: "Добавить вопросы",
            list_questions: "Список вопросов",
            destroy: "Выпилить"
          }
        }
      },
      profile_dashboard: {
        title: "Статистика по тестам",
        back: "← Назад к тестам",
        table: {
          test: "Тест",
          attempts: "Количество попыток",
          progress: "Прогресс"
        }
      },
      time_zone_selector: {
        header: "Часовой пояс"
      },
      login_dropdown: {
        title: "Войти",
        vk: "ВКонтакте",
        google_plus: "Google+"
      }
    }
  }
};

module.exports = I18n;

/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_FormErrors__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_FormErrors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_helpers_FormErrors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers_I18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers_I18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_helpers_I18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_application_AudioPlayer__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_application_LoginPage__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_application_SendUserbar__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_application_Wizard__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_application_Youtube__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_application_TestResults__ = __webpack_require__(148);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var TestWizard = function (_React$Component) {
  _inherits(TestWizard, _React$Component);

  function TestWizard() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TestWizard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TestWizard.__proto__ || Object.getPrototypeOf(TestWizard)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        choices: {},
        submitting: false,
        errors: new __WEBPACK_IMPORTED_MODULE_3_helpers_FormErrors___default.a()
      }
    }), Object.defineProperty(_this, 'handleSelectedAnswerChange', {
      enumerable: true,
      writable: true,
      value: function value(questionId, selectedAnswerId) {
        // timeout is necessary for non-immediate rendering
        if (_this.changeAnswerTimeout) {
          clearTimeout(_this.changeAnswerTimeout);
        }
        _this.changeAnswerTimeout = setTimeout(function () {
          var newChoices = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.extend({}, _this.state.choices);
          newChoices[questionId] = selectedAnswerId;
          _this.setState({ choices: newChoices });
          _this.refs.wizard.pageDone();
        }, 250);
      }
    }), Object.defineProperty(_this, 'handleTestDone', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({ submitting: true, errors: new __WEBPACK_IMPORTED_MODULE_3_helpers_FormErrors___default.a() });
        var modelForSubmit = _this.getModelForSubmit();
        __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(_this.props.submitURL).send(modelForSubmit).set("X-CSRF-Token", window.SessionManager.getCSRFToken()).set("Accept", "application/json").then(function (res) {
          _this.setState({ submitting: false });

          var correctAnswers = {};
          res.body.answers.forEach(function (a) {
            correctAnswers[a.question_id] = a.correct_answer_id;
          }, _this);

          if (!window.SessionManager.isLoggedIn()) {
            _this.props.setView(__WEBPACK_IMPORTED_MODULE_6_components_application_LoginPage__["a" /* default */], {
              testResultUUID: res.body.uuid,
              topicID: _this.props.test.topic.id
            });
          } else {
            history.replaceState({}, '', Routes.testResultURL(res.body.uuid));
            _this.props.setView(__WEBPACK_IMPORTED_MODULE_10_components_application_TestResults__["a" /* default */], {
              sendUserbarURL: _this.props.sendUserbarURL,
              sendUserbarMethod: _this.props.sendUserbarMethod,
              backURL: _this.props.backURL,
              uuid: res.body.uuid,
              questions: res.body.questions,
              answers: res.body.answers,
              score: res.body.correctly_answered_questions_count,
              totalQuestions: res.body.total_questions_count,
              userbarToken: res.body.userbar_token,
              topicId: res.body.topic.id
            });
          }
        }).catch(function (err) {
          var errors = void 0;
          if (err.status === 422) {
            errors = new __WEBPACK_IMPORTED_MODULE_3_helpers_FormErrors___default.a(err.response.body.errors.submission, "test_wizard.errors");
          } else {
            errors = new __WEBPACK_IMPORTED_MODULE_3_helpers_FormErrors___default.a({ errors: ["generic_error"] }, "test_wizard.errors");
          }
          _this.setState({ errors: errors, submitting: false });
        });
      }
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TestWizard, [{
    key: 'beganTest',
    value: function beganTest() {
      return !__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isEmpty(this.state.choices);
    }
  }, {
    key: 'getModelForSubmit',
    value: function getModelForSubmit() {
      var _this2 = this;

      var result = {
        topic_id: this.props.test.topic.id,
        submission: []
      };
      this.props.test.questions.forEach(function (q) {
        result.submission.push({
          question_id: q.id,
          selected_answer_id: _this2.state.choices[q.id]
        });
      });
      return result;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var pages = this.props.test.questions.map(function (q, i) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_components_application_Wizard__["a" /* default */].Page,
          { key: q.id },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TestWizard.Question, { id: q.id,
            number: i + 1,
            text: q.text,
            audioURL: q.audio_url,
            isPlaying: _this3.beganTest(),
            answerOptions: q.answer_options,
            selectedAnswerId: _this3.state.choices[q.id],
            onSelectedAnswerChange: _this3.handleSelectedAnswerChange }),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TestWizard.AudioPreloader, { audioURL: (_this3.props.test.questions[i + 1] || {}).audio_url })
        );
      });

      var alert = void 0;
      if (this.state.errors.hasAny()) {
        alert = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'alert alert-danger' },
          this.state.errors.firstError()
        );
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'page-header' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'h1',
            { className: 'm-b-0' },
            this.props.test.topic.name,
            '\xA0',
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'small',
              null,
              this.props.test.topic.level_name
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'col-md-8' },
            alert,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_components_application_Wizard__["a" /* default */],
              { className: 'test-wizard', ref: 'wizard', onDone: this.handleTestDone, submitting: this.state.submitting },
              pages
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'ul',
              { className: 'list-inline' },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'li',
                null,
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'a',
                  { href: this.props.backURL },
                  __WEBPACK_IMPORTED_MODULE_4_helpers_I18n___default.a.t("test_wizard.back")
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'col-md-4' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'm-b-05l' },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_application_Youtube__["a" /* default */], { videoEmbedURL: this.props.test.topic.video_url, controls: true, allowFullScreen: true })
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'p',
              null,
              this.props.test.topic.description
            )
          )
        )
      );
    }
  }]);

  return TestWizard;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Object.defineProperty(TestWizard, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    submitURL: __WEBPACK_IMPORTED_MODULE_2_react___default.a.PropTypes.string.isRequired,
    submitMethod: __WEBPACK_IMPORTED_MODULE_2_react___default.a.PropTypes.oneOf(["POST", "PATCH"]).isRequired,
    sendUserbarURL: __WEBPACK_IMPORTED_MODULE_2_react___default.a.PropTypes.string.isRequired,
    sendUserbarMethod: __WEBPACK_IMPORTED_MODULE_2_react___default.a.PropTypes.oneOf(["POST"]).isRequired,
    backURL: __WEBPACK_IMPORTED_MODULE_2_react___default.a.PropTypes.string.isRequired,
    test: __WEBPACK_IMPORTED_MODULE_2_react___default.a.PropTypes.object.isRequired,
    setView: __WEBPACK_IMPORTED_MODULE_2_react___default.a.PropTypes.func.isRequired
  }
});

var TestWizardQuestion = function (_React$Component2) {
  _inherits(TestWizardQuestion, _React$Component2);

  function TestWizardQuestion() {
    var _ref2;

    var _temp2, _this4, _ret2;

    _classCallCheck(this, TestWizardQuestion);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this4 = _possibleConstructorReturn(this, (_ref2 = TestWizardQuestion.__proto__ || Object.getPrototypeOf(TestWizardQuestion)).call.apply(_ref2, [this].concat(args))), _this4), Object.defineProperty(_this4, 'handleSelectedAnswerChange', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        var selectedAnswerId = Number(e.target.value);
        _this4.props.onSelectedAnswerChange(_this4.props.id, selectedAnswerId);
      }
    }), _temp2), _possibleConstructorReturn(_this4, _ret2);
  }

  _createClass(TestWizardQuestion, [{
    key: 'render',
    value: function render() {
      var _this5 = this;

      var audio = null;
      if (this.props.audioURL) {
        audio = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_application_AudioPlayer__["a" /* default */], { isPlaying: this.props.isPlaying, audioURL: this.props.audioURL });
      }
      var radios = this.props.answerOptions.map(function (ao) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'span',
          { key: ao.id, className: 'radio' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'label',
            { className: 'answer' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', { name: _this5.props.id,
              type: 'radio',
              value: ao.id,
              defaultChecked: _this5.props.selectedAnswerId === ao.id,
              onChange: _this5.handleSelectedAnswerChange }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'span',
              { className: 'radio-label' },
              ao.text
            )
          )
        );
      });
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'question' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'h4',
          null,
          __WEBPACK_IMPORTED_MODULE_4_helpers_I18n___default.a.t("test_wizard.question") + ' ' + this.props.number
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'p',
          { className: 'question-prominent p-t-20' },
          this.props.text
        ),
        audio,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'form-group p-t-15' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'h4',
            null,
            __WEBPACK_IMPORTED_MODULE_4_helpers_I18n___default.a.t("test_wizard.answer_options")
          ),
          radios
        )
      );
    }
  }]);

  return TestWizardQuestion;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Object.defineProperty(TestWizardQuestion, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    id: __WEBPACK_IMPORTED_MODULE_2_react___default.a.PropTypes.number.isRequired,
    number: __WEBPACK_IMPORTED_MODULE_2_react___default.a.PropTypes.number.isRequired,
    text: __WEBPACK_IMPORTED_MODULE_2_react___default.a.PropTypes.string.isRequired,
    audioURL: __WEBPACK_IMPORTED_MODULE_2_react___default.a.PropTypes.string,
    isPlaying: __WEBPACK_IMPORTED_MODULE_2_react___default.a.PropTypes.bool,
    answerOptions: __WEBPACK_IMPORTED_MODULE_2_react___default.a.PropTypes.arrayOf(__WEBPACK_IMPORTED_MODULE_2_react___default.a.PropTypes.object).isRequired,
    selectedAnswerId: __WEBPACK_IMPORTED_MODULE_2_react___default.a.PropTypes.number,
    onSelectedAnswerChange: __WEBPACK_IMPORTED_MODULE_2_react___default.a.PropTypes.func.isRequired
  }
});

var TestWizardAudioPreloader = function (_React$Component3) {
  _inherits(TestWizardAudioPreloader, _React$Component3);

  function TestWizardAudioPreloader() {
    _classCallCheck(this, TestWizardAudioPreloader);

    return _possibleConstructorReturn(this, (TestWizardAudioPreloader.__proto__ || Object.getPrototypeOf(TestWizardAudioPreloader)).apply(this, arguments));
  }

  _createClass(TestWizardAudioPreloader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.audioURL) {
        return;
      }
      this.refs.audio.src = this.props.audioURL;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('audio', { ref: 'audio' });
    }
  }]);

  return TestWizardAudioPreloader;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Object.defineProperty(TestWizardAudioPreloader, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    audioURL: __WEBPACK_IMPORTED_MODULE_2_react___default.a.PropTypes.string
  }
});


TestWizard.Question = TestWizardQuestion;
TestWizard.AudioPreloader = TestWizardAudioPreloader;
/* harmony default export */ __webpack_exports__["a"] = (TestWizard);

/***/ }),

/***/ 437:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_helpers_I18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_helpers_I18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_helpers_I18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var LoginPage = function (_React$Component) {
  _inherits(LoginPage, _React$Component);

  function LoginPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LoginPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LoginPage.__proto__ || Object.getPrototypeOf(LoginPage)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleClick', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        e.preventDefault();
        window.location.href = e.target.href;
      }
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LoginPage, [{
    key: 'authHrefWithState',
    value: function authHrefWithState(href) {
      return href + '?state=' + encodeURIComponent(this.props.testResultUUID);
    }
  }, {
    key: 'noAuthHref',
    value: function noAuthHref() {
      return '/tests/' + this.props.testResultUUID;
    }
  }, {
    key: 'render',
    value: function render() {
      var text = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'p',
        null,
        __WEBPACK_IMPORTED_MODULE_1_helpers_I18n___default.a.t("login_page.text")
      );

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: '' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'page-header' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'h1',
            { className: 'm-b-0' },
            __WEBPACK_IMPORTED_MODULE_1_helpers_I18n___default.a.t("login_page.title")
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'p-b-20' },
          text
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'container' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'row m-tb-5' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'a',
              { href: this.authHrefWithState("/auth/vkontakte"),
                className: 'col-md-2 text-left btn btn-vk',
                onClick: this.handleClick },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'fa fa-vk' }),
              ' Vkontakte'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'row m-tb-5' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'a',
              { href: this.authHrefWithState("/auth/google_oauth2"),
                className: 'col-md-2 text-left btn btn-google',
                onClick: this.handleClick },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'fa fa-google' }),
              ' Google+'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'row m-tb-5 p-t-20' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'a',
              { href: this.noAuthHref() },
              __WEBPACK_IMPORTED_MODULE_1_helpers_I18n___default.a.t("login_page.skip")
            )
          )
        )
      );
    }
  }]);

  return LoginPage;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Object.defineProperty(LoginPage, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    testResultUUID: __WEBPACK_IMPORTED_MODULE_2_react___default.a.PropTypes.string.isRequired,
    topicID: __WEBPACK_IMPORTED_MODULE_2_react___default.a.PropTypes.number
  }
});


/* harmony default export */ __webpack_exports__["a"] = (LoginPage);

/***/ }),

/***/ 439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_helpers_I18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_helpers_I18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_helpers_I18n__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Wizard = function (_React$Component) {
  _inherits(Wizard, _React$Component);

  function Wizard() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Wizard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Wizard.__proto__ || Object.getPrototypeOf(Wizard)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        currentPageIndex: 0,
        furthestPageIndex: 0,
        allDone: false
      }
    }), Object.defineProperty(_this, 'previousPage', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        if (e) {
          e.preventDefault();
        }
        _this.setState({ currentPageIndex: _this.state.currentPageIndex - 1 });
      }
    }), Object.defineProperty(_this, 'pageDone', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.isLastPage()) {
          _this.setState({ allDone: true });
        } else {
          _this.nextPage();
        }
      }
    }), Object.defineProperty(_this, 'nextPage', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        if (e) {
          e.preventDefault();
        }
        if (_this.isLastPage()) {
          return;
        }
        _this.setState({
          currentPageIndex: _this.state.currentPageIndex + 1,
          furthestPageIndex: Math.max(_this.state.furthestPageIndex, _this.state.currentPageIndex + 1)
        });
      }
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Wizard, [{
    key: 'progress',
    value: function progress() {
      return 100 * (this.state.currentPageIndex + 1) / this.props.children.length;
    }
  }, {
    key: 'isFirstPage',
    value: function isFirstPage() {
      return this.state.currentPageIndex === 0;
    }
  }, {
    key: 'isLastPage',
    value: function isLastPage() {
      return this.state.currentPageIndex === this.props.children.length - 1;
    }
  }, {
    key: 'seenNextPage',
    value: function seenNextPage() {
      return this.state.currentPageIndex < this.state.furthestPageIndex;
    }
  }, {
    key: 'renderNav',
    value: function renderNav() {
      var navButtons = [];
      if (!this.isFirstPage()) {
        navButtons.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: 'btn btn-default', key: 'back', href: 'javascript:;', onClick: this.previousPage },
          __WEBPACK_IMPORTED_MODULE_1_helpers_I18n___default.a.t("test_wizard.previous")
        ));
      }
      if (this.seenNextPage()) {
        navButtons.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: 'btn btn-default', key: 'next', href: 'javascript:;', onClick: this.nextPage },
          __WEBPACK_IMPORTED_MODULE_1_helpers_I18n___default.a.t("test_wizard.next")
        ));
      }

      var navBtnGroup = navButtons.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group form-group' },
        navButtons
      ) : null;

      var submitButton = void 0;
      if (this.state.allDone) {
        submitButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'pull-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn btn-primary', disabled: this.props.submitting, onClick: this.props.onDone },
            __WEBPACK_IMPORTED_MODULE_1_helpers_I18n___default.a.t("test_wizard.submit")
          )
        );
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'wizard-nav clearfix' },
        navBtnGroup,
        submitButton
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: this.props.className },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'wizard-pages' },
          this.props.children[this.state.currentPageIndex]
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'progress' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'progress-bar progress-bar-striped',
            role: 'progressbar',
            'aria-valuenow': this.progress(),
            'aria-valuemin': '0',
            'aria-valuemax': '100',
            style: { width: this.progress().toString() + '%' } })
        ),
        this.renderNav()
      );
    }
  }]);

  return Wizard;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Object.defineProperty(Wizard, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    className: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.string,
    submitting: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.bool,
    onDone: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.func.isRequired
  }
});

var WizardPage = function (_React$Component2) {
  _inherits(WizardPage, _React$Component2);

  function WizardPage() {
    _classCallCheck(this, WizardPage);

    return _possibleConstructorReturn(this, (WizardPage.__proto__ || Object.getPrototypeOf(WizardPage)).apply(this, arguments));
  }

  _createClass(WizardPage, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'test-wizard-page' },
        this.props.children
      );
    }
  }]);

  return WizardPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Wizard.Page = WizardPage;
/* harmony default export */ __webpack_exports__["a"] = (Wizard);

/***/ }),

/***/ 445:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_application_MainView__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_application_TestWizard__ = __webpack_require__(348);





document.addEventListener('DOMContentLoaded', function () {
  var node = document.getElementById('content');
  var data = JSON.parse(node.getAttribute('data'));

  var AudiotrainerMainView = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_application_MainView__["a" /* default */], {
    initialViewType: __WEBPACK_IMPORTED_MODULE_3_components_application_TestWizard__["a" /* default */],
    initialViewData: data
  });
  __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(AudiotrainerMainView, node);
});

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var I18n = __webpack_require__(15);

var FormErrors = function () {
  function FormErrors(errors, i18nScope) {
    _classCallCheck(this, FormErrors);

    this._i18nScope = i18nScope;
    this._ownErrors = [];
    this._nestedErrors = {};

    switch (Object.prototype.toString.call(errors)) {
      case "[object Array]":
        this._ownErrors = errors;
        break;
      case "[object Object]":
        if (errors.errors !== undefined) {
          this._ownErrors = errors.errors.slice();
        }
        this._nestedErrors = errors;
        break;
      default:
      // ignore
    }

    return this;
  }

  _createClass(FormErrors, [{
    key: "get",
    value: function get(name, i18nSubscope) {
      var nextI18nScope = this._i18nScope;
      if (i18nSubscope === undefined) {
        nextI18nScope += "." + name;
      } else if (i18nSubscope != "") {
        nextI18nScope += "." + i18nSubscope;
      }
      if (this._nestedErrors.hasOwnProperty(name)) {
        return new FormErrors(this._nestedErrors[name], nextI18nScope);
      } else {
        return new FormErrors();
      }
    }
  }, {
    key: "firstError",
    value: function firstError() {
      var first = this._ownErrors[0];
      if (first !== undefined) {
        return I18n.t(this._i18nScope + "." + first);
      }
      return undefined;
    }
  }, {
    key: "hasAny",
    value: function hasAny() {
      return this.firstError() !== undefined;
    }
  }, {
    key: "remove",
    value: function remove(name) {
      if (this._nestedErrors.hasOwnProperty(name)) {
        delete this._nestedErrors[name];
      }
    }
  }]);

  return FormErrors;
}();

module.exports = FormErrors;

/***/ })

},[445]);


// WEBPACK FOOTER //
// test-544a8c37ee3e76758658.js